import MappingBuilderModel from "../tracked/mappingBuilderModel";
import Guid from "../../helpers/guid";
import {IOriginWrapper, TMappingOriginType} from "~/interfaces/mappingInterfaces";
import {IDefaultVOption} from "~/interfaces/vSelectInterfaces";
import {RelationType} from "~/models/relationType";
import RelationIdentifier from "~/models/mapping/relationIdentifier";
import ModelCollection from "~/models/modelCollection";
import MappingOriginOptionObjectModelRelation from "~/models/mapping/mappingOriginOptionObjectModelRelation";

export default abstract class MappingOrigin extends MappingBuilderModel implements IOriginWrapper {
  abstract readonly friendly_type: TMappingOriginType = null;
  relation_identifiers: ModelCollection<RelationIdentifier> = new ModelCollection<RelationIdentifier>()

  constructor() {
    super();
    this.defineProperty('client_id', Guid.create());
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      relation_identifiers: {type: RelationIdentifier, relationType: RelationType.collection}
    };
  }

  createEmbeddedObject = {
    relation_identifiers: (parent, json): RelationIdentifier => {
      return new RelationIdentifier(parent).loadFromJson(json, parent);
    },
  }

  // omit this for a bad time
  get isCollectionRoot(): boolean {
    return false;
  }

  // remove this override if ._nameInParent takes off
  get rootName(): string {
    return this._nameInParent;
  }

  abstract get root(): IOriginWrapper

  get object(): any {
    return this.root.object
  }

  get value(): IDefaultVOption {
    return this.root.value
  }

  abstract get relationshipModels(): any

  abstract get rootIdentifier(): string
  abstract set rootIdentifier(value: string)

  abstract get modelIdentifiers(): string[]
  abstract set modelIdentifiers(value: string[])

  get relationIdentifiers(): ModelCollection<RelationIdentifier> {
    return this.relation_identifiers
  }

  get type(): TMappingOriginType {
    return this.friendly_type
  }

  is(...types: Array<TMappingOriginType>): boolean {
    return types.includes(this.type);
  }

  // ******************** NESTED MODEL MAPPING ******************** //
  /**
   * Should override in subclasses
   * Determines if a nested model mapping source/destination can also set up a relationship
   * to the main, top-level root object
   * @pt #175817265
   */
  get canRelateToRoot(): boolean {
    return false
  }

  /**
   * This goes along with #canRelationToRoot
   * @see MappingOrigin#canRelateToRoot
   */
  nestedToRootAvailableOptions(rootObject): MappingOriginOptionObjectModelRelation[] {
    return []
  }
  // ******************** NESTED MODEL MAPPING END ******************** //
}
